import React, { Component } from 'react';

import { FormEdit } from 'Components/FormEdit';
import IntInput, { normalizeInt } from 'Components/inputs/Integer';
import SelectConstant from 'FDComponents/constants/Select';
import SelectAgeGroup from 'FDComponents/ageGroups/Select';
import TextInput from 'Components/inputs/Text';
import Toggle, { normalizeBoolean } from 'Components/inputs/Toggle';
import Float from "Components/inputs/Float";

export default class Form extends Component {
  config = {
    fields: [
      'id',
      'name',
      'shortName',
      'code',
      'gender',
      'priority',
      'featuredForBroadcast',
      'metaImportGSMUuid',
      'mercatoBudget'
    ],
    objectFields: ['ageGroup'],
    disposition: [
      {
        fields: [
          { name: 'name', component: TextInput, size: 6 },
          { name: 'shortName', component: TextInput, size: 6 },
          { name: 'code', component: TextInput, size: 6 },
          { name: 'ageGroup', component: SelectAgeGroup, size: 6 },
          {
            name: 'gender',
            component: SelectConstant,
            entity: 'team',
            size: 6,
          },
          {
            name: 'priority',
            component: IntInput,
            normalize: normalizeInt,
            size: 6,
          },
          { name: 'metaImportGSMUuid', component: TextInput, size: 6 },
          {
            name: 'featuredForBroadcast',
            component: Toggle,
            normalize: normalizeBoolean,
            size: 6,
          },
          { name: 'mercatoBudget', component: Float, size: 6 },
        ],
      },
    ],
  };

  render() {
    const { data, onSubmit } = this.props;

    return (
      <FormEdit
        key={data.id}
        form={`team_${data.id}`}
        onSubmit={onSubmit}
        data={data}
        config={this.config}
        main
        useUserRestriction
      />
    );
  }
}
